import type { ApiClient, IApiJsonRequest } from '../../ApiClient';
import type {
  IApiGetPictureResponseBody,
  IApiGetPicturesRequestBody,
  IApiGetPicturesResponseBody,
} from './PicturesApi.types';

export class PicturesApi {
  public constructor(private client: ApiClient) {}

  public async get(
    appId: string | undefined,
    pictureId: string,
  ): Promise<IApiGetPictureResponseBody> {
    const request: IApiJsonRequest = {
      path: `/pictures/${pictureId}`,
      method: 'get',
    };

    const response = await this.client.fetchJson<IApiGetPictureResponseBody>(
      request,
      { appId },
    );

    return response.body;
  }

  public async getAll(
    appId: string,
    body?: IApiGetPicturesRequestBody,
  ): Promise<IApiGetPicturesResponseBody> {
    const request: IApiJsonRequest = {
      path: '/pictures',
      method: 'get',
      params: body,
    };

    const response = await this.client.fetchJson<IApiGetPicturesResponseBody>(
      request,
      {
        appId,
      },
    );

    return response.body;
  }
}
